import axiosClient from "api/apiClient";

export const APIPostForgotPassword = (data: object) => {
    return axiosClient.post("/forgot-password", data);
  };

  export const APIPostResetPassword = (data: object) => {
    return axiosClient.post("/reset-password", data);
  };
